import { InjectionToken } from '@angular/core';
import type { PaymentEnvironment } from '@env/environment.model';

export type { PaymentEnvironment } from '@env/environment.model';

export const PAYMENT_ENV = new InjectionToken<PaymentEnvironment>('PAYMENT_ENV');
